import { api } from '../../api'

const makeParams = ({ years, departments, activeTab }) => {
  const params = new URLSearchParams()
  years?.forEach((y) => {
    params.append('year[]', y)
  })
  departments?.forEach((id) => {
    params.append('department_id[]', id)
  })
  if (!(activeTab == null)) {
    params.append('group_by_year', activeTab)
  }
  return params
}

export const dmpRentabilityApi = api
  .enhanceEndpoints({
    addTagTypes: ['department-rent'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getRentByFilters: builder.query({
        providesTags: ['department-rent'],
        query: ({ years, departments, activeTab }) => ({
          url: '/dmp/department-rent',
          method: 'GET',
          params: makeParams({ years, departments, activeTab }),
        }),
        transformResponse: (response) => response?.data || [],
      }),
      getRentReport: builder.mutation({
        query: ({ years, departments, activeTab }) => ({
          url: `/dmp/department-rent/xlsx`,
          method: 'GET',
          params: makeParams({ years, departments, activeTab }),
          responseHandler: async (response) => response.blob(),
        }),
      }),
    }),
  })

export const { useLazyGetRentByFiltersQuery, useGetRentReportMutation } =
  dmpRentabilityApi
